import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAdditionalFormsFieldsWorkspaceCreationDialog, LazyAutoComplete, LazyCheckbox, LazyInputGroup, LazyInputMask, LazyInputNumber, LazyInputText, LazyMultiSelect, LazyPassword, LazyRadioButton, LazySelect, LazySlider, LazyTextarea, LazyToggleSwitch, LazyButton, LazySplitButton, LazyColumn, LazyDataTable, LazyDataView, LazyOrganizationChart, LazyPaginator, LazyTree, LazyCard, LazyDivider, LazyStepper, LazyStepList, LazyStep, LazyStepPanels, LazyStepPanel, LazyTabs, LazyTabList, LazyTab, LazyTabPanels, LazyTabPanel, LazyConfirmDialog, LazyConfirmPopup, LazyDialog, LazyPopover, LazyFileUpload, LazyBreadcrumb, LazyMenu, LazyTieredMenu, LazyToast, LazyImage, LazyAvatar, LazyAvatarGroup, LazyBadge, LazySkeleton, LazyProgressBar, LazyProgressSpinner, LazyTag } from '#components'
const lazyGlobalComponents = [
  ["AdditionalFormsFieldsWorkspaceCreationDialog", LazyAdditionalFormsFieldsWorkspaceCreationDialog],
["AutoComplete", LazyAutoComplete],
["Checkbox", LazyCheckbox],
["InputGroup", LazyInputGroup],
["InputMask", LazyInputMask],
["InputNumber", LazyInputNumber],
["InputText", LazyInputText],
["MultiSelect", LazyMultiSelect],
["Password", LazyPassword],
["RadioButton", LazyRadioButton],
["Select", LazySelect],
["Slider", LazySlider],
["Textarea", LazyTextarea],
["ToggleSwitch", LazyToggleSwitch],
["Button", LazyButton],
["SplitButton", LazySplitButton],
["Column", LazyColumn],
["DataTable", LazyDataTable],
["DataView", LazyDataView],
["OrganizationChart", LazyOrganizationChart],
["Paginator", LazyPaginator],
["Tree", LazyTree],
["Card", LazyCard],
["Divider", LazyDivider],
["Stepper", LazyStepper],
["StepList", LazyStepList],
["Step", LazyStep],
["StepPanels", LazyStepPanels],
["StepPanel", LazyStepPanel],
["Tabs", LazyTabs],
["TabList", LazyTabList],
["Tab", LazyTab],
["TabPanels", LazyTabPanels],
["TabPanel", LazyTabPanel],
["ConfirmDialog", LazyConfirmDialog],
["ConfirmPopup", LazyConfirmPopup],
["Dialog", LazyDialog],
["Popover", LazyPopover],
["FileUpload", LazyFileUpload],
["Breadcrumb", LazyBreadcrumb],
["Menu", LazyMenu],
["TieredMenu", LazyTieredMenu],
["Toast", LazyToast],
["Image", LazyImage],
["Avatar", LazyAvatar],
["AvatarGroup", LazyAvatarGroup],
["Badge", LazyBadge],
["Skeleton", LazySkeleton],
["ProgressBar", LazyProgressBar],
["ProgressSpinner", LazyProgressSpinner],
["Tag", LazyTag],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
